var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.496 14L69.1543 47.8662L77.7719 27.9079L115.496 14Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6126 14.04L50.2358 27.9105L58.4185 48.1305L12.6126 14.04ZM96.848 86.0242L117.33 86.4092L110.172 110.427L85.1789 103.63L96.848 86.0242ZM31.1532 86.0242L42.7788 103.63L17.8278 110.427L10.7129 86.4092L31.1532 86.0242Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3058 42.9796L58.1428 69.6808L33.0957 68.5554L40.2203 57.9396L40.3106 57.8375L57.3058 42.9796ZM70.4359 42.6816L87.6905 57.8383L87.78 57.94L94.9046 68.5558L69.863 69.6808L70.4359 42.6816ZM43.5122 86.1012L57.1886 96.6258L41.3016 104.201L43.5122 86.1012ZM84.4915 86.0996L86.6561 104.202L70.8134 96.625L84.4915 86.0996Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1622 95.6338L87.2386 103.322L72.2844 110.341L72.4397 105.702L71.1622 95.6338ZM56.8324 95.6371L55.6052 105.626L55.706 110.336L40.7168 103.322L56.8324 95.6371Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1897 73.166L56.3907 81.886L42.0879 77.7477L52.1897 73.166ZM75.8084 73.1669L85.9578 77.7477L71.6082 81.8848L75.8084 73.1669Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.604 86.0121L42.2921 104.779L29.9004 86.4225L44.604 86.0121ZM83.3954 86.0125L98.0994 86.4225L85.6613 104.78L83.3954 86.0125ZM95.2653 67.4941L84.5644 78.2654L76.3138 74.5416L72.3638 82.7433L69.7743 68.6396L95.2653 67.4941ZM32.7278 67.4941L58.2238 68.6396L55.6339 82.7433L51.6831 74.5429L43.4763 78.2658L32.7278 67.4941Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0078 65.2844L44.1148 77.4181L44.5341 89.3969L32.0078 65.2844ZM96.005 65.2627L83.4559 89.4181L83.9284 77.4181L96.005 65.2627ZM57.6329 66.0235L58.1202 69.0527L59.3242 76.5989L58.5501 99.776L54.8903 81.1573L54.889 80.9648L57.6329 66.0235ZM70.3613 65.9814L73.1124 80.9648L73.1111 81.1573L69.442 99.8227L69.2969 95.1539L68.7244 76.4614L70.3613 65.9814Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0034 76.9355L84.5938 87.343L71.8219 97.171L69.24 95.3693L72.1341 80.6464L85.0034 76.9355ZM43.0391 76.9355L55.8636 80.6464L58.7577 95.3693L56.1758 97.171L43.4036 87.3422L43.0391 76.9355Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2734 101.024L54.6135 108.671L54.5443 105.406L55.9116 104.22H72.0838L73.5004 105.401L73.3958 108.664L89.6325 101.044L81.7316 107.492L72.1783 113.972H55.7804L46.2334 107.465L38.2734 101.024Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9923 94.6162L72.3025 96.2283L73.6563 106.897L71.6971 105.263H56.3088L54.3867 106.93L55.6962 96.2291L58.0073 94.6162H69.9923Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.437 14.9375L118 31.4196L114.526 48.085L117 49.9696L113.652 52.4921L116.168 54.4112L112.837 57.4075L114.882 58.8704L109.454 65.1312L87.1917 58.7292L86.9989 58.6271L70.9563 45.2612L112.437 14.9375ZM15.5628 14.9375L57.0441 45.2612L41.0011 58.6271L40.8083 58.7292L18.5459 65.1312L13.1181 58.8704L15.1616 57.4087L11.8322 54.4112L14.3432 52.4942L10.9454 49.9646L13.5125 48.0787L10 31.4204L15.5628 14.9375Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1023 57.3294L109.691 64.1123L117.354 87.4398H97.136L83.2057 87.6131L93.3366 68.1098L86.1023 57.3294ZM41.8965 57.3294L34.661 68.1098L44.7931 87.6131L30.8692 87.4398H10.6875L18.3078 64.1127L41.8965 57.3294ZM78.927 27.7969L72.3293 45.3965L70.9291 69.1715L70.3934 76.6235L70.3507 95.6602H57.6477L57.6063 76.6594L57.0689 69.1652L55.6682 45.3965L49.0714 27.7969H78.927Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 100,
    fill: "white",
    transform: "translate(10 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask-icon.5385b6061d9954f09f4bfc158e5f0c9e.svg";
export { ForwardRef as ReactComponent };